import { render, staticRenderFns } from "./DetailCommandeFournisseur.vue?vue&type=template&id=df6ca9c0&"
import script from "./DetailCommandeFournisseur.vue?vue&type=script&lang=js&"
export * from "./DetailCommandeFournisseur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports